/* eslint-disable*/
import {Component} from "react";
import Header from "../../../components/Header/Header";
import {Container, Row, Col, CardImg, Card, Button} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import React from "react";
import './ViewLecture.scss';
import * as constants from "../../../const/constants";
import {withRouter} from "react-router";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";
import * as actionCreator from "../../../store/domain/classes/action";
import connect from "react-redux/es/connect/connect";
import * as commonFunc from "../../../utils/commonFunc";
import moment from "moment";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as classService from "../../../services/class";
import * as actionModalCreator from "../../../store/domain/modal/action";
import {lang, language} from "../../../const/language";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import swal from "sweetalert";
import {setPaymentModal_} from "../../../store/domain/modal/action";

import {Replay} from 'vimond-replay';
import 'vimond-replay/index.css';
import HlsjsVideoStreamer from 'vimond-replay/video-streamer/hlsjs';
import VideoPLayer from "../../../components/VideoPlayer/VideoPLayer";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/19/20
 * Time: 1:19 PM
 */
class App extends Component {
    handlePageClick = (value) => {
        this.fetchClassesFromHome(value.selected);
    };
    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };

    checkClass = async () => {
        let state = this.props.location.state;
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsById(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    checkClassByToken = async () => {
        let state = this.props.location.state;
        console.log(state);
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsByIdWithToken(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    purchaseHandler = (date, classId) => {
        this.props.setPaymentModal(true, {classId: classId})
        // let months = dropdownConst.months;
        // let curMonth = new Date(date).getMonth();
        // let curYear = new Date(date).getFullYear();
        //
        // let obj = { month: months[curMonth].value, year: curYear, classId: classId };
        // commonFunc.studentPurchaseWarning(this.props, obj);
    };
    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    viewClassLessons = () => {
        commonFunc.viewClassResources(this.props,this.props.location.state);
    }

    componentWillUnmount() {
        this.props.selectClassHandler(null);
    }

    // componentDidMount() {
    //     document.documentElement.scrollTop = 0;
    //     document.scrollingElement.scrollTop = 0;
    //     this.refs.main.scrollTop = 0;
    //     this.checkClass();
    //
    // }

    async componentDidMount(){
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;

        let pathname = this.props.location.pathname;
        let array = pathname.split('/');
        let hashCode = (array[array.length - 1]);
        let checkType = (array[array.length - 2]);
        this.props.spinnerHandler({isSpin: true, type: 15});
        if (hashCode.length === 6 && checkType === 'pay-class') {
            classService.paymentUrlNavigation(hashCode).then(res => {
                if (res.success) {
                    let isEnrolled = res.body.enrolled;
                    // this.props.spinnerHandler({isSpin: true, type: 10});
                    classService.getClassDetailsById(res.body.classId)
                        .then(response => {
                            this.props.spinnerHandler(false);
                            if (response.success) {
                                this.props.selectClassHandler(response.body);
                                if (!isEnrolled) {
                                    this.props.setPaymentModal(true, {classId: res.body.classId,classDetails:response.body})
                                }
                            } else {
                                commonFunc.notifyMessage(response.message, response.status);
                                this.goHome();
                            }
                        })
                } else {
                    this.goHome();
                }

            })
        } else if (hashCode.length === 6 && checkType === 'join-class') {
            classService.JoinClassNavigation(hashCode).then(
                response => {
                    if (!response.success) {
                        this.props.spinnerHandler(false);
                        classService.getClassDetailsByHashcode(hashCode).then(res=>{
                            let classDetails =res.body;
                            this.props.selectClassHandler(classDetails);
                            this.props.location.state = classDetails.id;
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                                state: `${classDetails.id}`
                            })
                        });
                        notifyMessage(response.message, response.status);
                    } else {
                        let obj;
                        let body = response.body;
                        if (body.zoomMeetingJoinType === 'UNAUTHORIZED') {
                            obj = {
                                zoomMeetingId: body.zoomMeetingId,
                                zoomMeetingPassword: body.zoomMeetingPassword,
                                zoomSignatureJwt: body.zoomSignatureJwt,
                                classId: body.classId,
                                zoomMeetingJoinType: body.zoomMeetingJoinType
                            };
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                state: obj
                            })
                        } else {
                            classService.joinZoomClassAuthorized(body.classId).then(res => {
                                if (res.success) {
                                    this.props.spinnerHandler(false);
                                    obj = {
                                        link: res.body,
                                        zoomMeetingJoinType: 'AUTHORIZED'
                                    };
                                    // this.props.history.props.spinnerHandler(false);
                                    this.props.history.props.push({
                                        pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                        state: obj
                                    })
                                } else {
                                    //props.spinnerHandler(false);
                                    this.props.spinnerHandler(false);
                                    let msgType = 'warning';
                                    toastr[msgType](res.message);
                                }
                            }).catch(err => {
                                this.props.spinnerHandler(false);
                                console.log(err)
                            });
                        }


                    }
                }
            )
        } else {
            if(this.props.location.search.split('?paynow=')[1] === 'Y'){
                await this.checkClass();
                document.getElementById("pay-btn").click();
            }else{
                await this.checkClassByToken();
            }


        }



    }

    joinClass = (selectClass) => {
        if(this.props.userType === 1){
            commonFunc.joinClassHandler(this.props, selectClass)
        }else {
            swal({
                title: language[lang].StudentSignInWarning3,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        break;
                    default:
                        break;
                }
            });
        }
    };

    viewClassPapers = (object) => {
        commonFunc.viewPaperResources(this.props,object.id);
    }

    render() {
        let {selectClass, userType} = this.props;
        let firstWeek = new Date().getDate() <= 12;

        return (
            <div className={userType !== 1 ?"guest-user-view-class lec-view-class":"lec-view-class"}>
                <Header/>
                <Row>
                    <Col className={"col-poly"}>
                        <SectionPolygon/>
                    </Col>
                </Row>

                <div>
                    <main ref="main">
                        <section className={"section "}>
                            <Container className="  abouts ">
                                {
                                    selectClass &&

                                    <div className={`${selectClass.isExpired ? `expire-layout ` : `un-expire-layout`}`}>

                                        <AuthButtonGroup userType={userType} />

                                        <Row className="about">
                                            <Col className={"col-img"}>
                                                <button className={"home-btn"}
                                                        onClick={() => this.setModalHandler(null)}
                                                >
                                                    <i className="icofont-long-arrow-left"/>
                                                    {language[lang].BackToTour}
                                                </button>
                                                {
                                                    selectClass.videoUrl ?
                                                        <div className={"videoHolder"}>
                                                            <Card className={"halfWidth"}>
                                                                {/*<Replay*/}
                                                                {/*    source={selectClass.videoUrl}*/}
                                                                {/*    initialPlaybackProps={{isPaused: true}}*/}
                                                                {/*>*/}
                                                                {/*    <HlsjsVideoStreamer/>*/}
                                                                {/*</Replay>*/}
                                                                <VideoPLayer class={true} video={selectClass.videoUrl}/>

                                                            </Card>
                                                        </div> :

                                                        <Card className={"card-img"}>

                                                            <CardImg className={"main-img"} alt="."
                                                                     src={selectClass.imageUrl}/>
                                                        </Card>
                                                }

                                            </Col>
                                        </Row>

                                        <br/>
                                        <Row className="about">
                                            <Col lg="12" className={"col-name"}>
                                                <p className={"head-topic"}>{`${selectClass.name} - ${selectClass.subject}`}</p>
                                                <p className={"head-teacher"}> by {`${selectClass.teacher.teacherName}`}</p>
                                            </Col>
                                            <Col lg={12}>
                                                <div className={"lec-desc-wrapper"}>
                                                    <p className={"lec-desc"}>{selectClass.description}</p>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="about">

                                            {
                                                selectClass.dayTimes.length !== 0 &&
                                                <Col lg="3" className={"col-shedule"}>
                                                    <Card className={"card-shedule"}>
                                                        <div>
                                                            <ul><p
                                                                className={"card-topic"}>{language[lang].ClassSchedule}</p>
                                                            </ul>
                                                            {
                                                                selectClass.dayTimes.length !== 0 ? selectClass.dayTimes.map((dayTime, i) => (
                                                                        <ul className={"card-cont day-list"}>
                                                                            <li>
                                                                                <p
                                                                                    key={i}>{`${language[lang][dayTime.day]}:`}</p>
                                                                                <p>

                                                                                    {`${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm a')}`}</p>
                                                                            </li>
                                                                        </ul>)) :
                                                                    <ul className={"card-cont day-list"}>
                                                                        <p>-</p>
                                                                        <p>-</p>
                                                                    </ul>
                                                            }
                                                            {
                                                                (selectClass.nextDayOfClass !== undefined && selectClass.nextDayOfClass !== null) &&
                                                                <ul className={"card-cont next-list"}>
                                                                    <li>

                                                                        <span> {`${language[lang].NextClassIsOn}`} </span></li>
                                                                    <p className={"next-day"}>
                                                                        {moment(selectClass.nextDayOfClass.replace("Z", "")).format("YYYY MMM DD")} </p>
                                                                </ul>
                                                            }

                                                        </div>
                                                    </Card>
                                                </Col>
                                            }
                                            {
                                                selectClass.syllabus && selectClass.syllabus.trim() !== "" &&
                                                <Col lg="9" className={"col-syllebus"}>
                                                    <Card className={"card-syllebus"}>
                                                        <ul><p className={"card-topic"}>{language[lang].Syllabus}</p>
                                                        </ul>


                                                        <div>
                                                            {
                                                                <div>
                                                                    {
                                                                        selectClass.syllabus.split(",").map((syllabus, index) => (
                                                                                <p>
                                                                                    <ul className={"card-cont day-list"}>
                                                                                        <li key={index}>
                                                                                            {`${syllabus}`}</li>
                                                                                    </ul>
                                                                                </p>
                                                                            )
                                                                        )
                                                                    }
                                                                </div>
                                                            }
                                                        </div>

                                                    </Card>
                                                </Col>
                                            }
                                            {
                                                selectClass.enrolledMonths && selectClass.enrolledMonths.length !== 0 &&
                                                <Col lg={3} className={"col-shedule"}>
                                                    <Card className={"card-pur-months"}>

                                                        <div className={"lec-syllabus_"}>
                                                            <ul><p
                                                                className={"card-topic"}> {language[lang].PurchaseMonths} </p>
                                                            </ul>

                                                            {
                                                                selectClass.enrolledMonths.map((month, index) => (
                                                                    <p>
                                                                        <ul className={"card-cont day-list"}>
                                                                            <li key={index}
                                                                                className={"syllabus "}>{`${month.year} - ${language[lang][month.month]}`}</li>

                                                                        </ul>
                                                                    </p>
                                                                ))
                                                            }

                                                        </div>
                                                    </Card>
                                                </Col>
                                            }

                                            <Col lg="9" className={"none-padding"}>

                                                {
                                                    selectClass.fee === 0 ?
                                                        <div className={"button-ctrl"}>
                                                            {
                                                                (selectClass.teacher.privileges.split(':')[0] === '1' &&
                                                                    userType === 1) ?
                                                                    <Button
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => commonFunc.joinClassHandler(this.props, selectClass)}>
                                                                        {`${language[lang].JoinTheClass}`}
                                                                    </Button> : null
                                                            }
                                                            {/*{*/}
                                                            {/*    (selectClass.teacher.privileges.split(':')[1] === '1' &&*/}
                                                            {/*        selectClass.buttonStatus === constants.BOUGHT_TEXT) ?*/}
                                                            {/*        <Button*/}
                                                            {/*            className="com-btn log-btn mt-3 auto-width"*/}
                                                            {/*            onClick={() => this.viewClassLessons()}>*/}
                                                            {/*            {`${language[lang].ClassResources}`}*/}
                                                            {/*        </Button> : null*/}
                                                            {/*}*/}
                                                            {
                                                                (selectClass.teacher.privileges.split(':')[3] === '1' &&
                                                                    selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                                    <Button
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => this.viewClassPapers(selectClass)}>
                                                                        {`${language[lang].QuizesAndTestPapers}`}
                                                                    </Button> : null
                                                            }
                                                        </div> :
                                                        <div className={"button-ctrl"}>

                                                            {
                                                                (selectClass.teacher.privileges.split(':')[0] === '1' &&
                                                                    (selectClass.firstWeekFree && firstWeek) &&
                                                                    selectClass.buttonStatus === constants.BUY_TEXT) ?
                                                                    <Button
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => this.joinClass(selectClass)}>
                                                                        {`${language[lang].JoinTheClass}`}
                                                                    </Button> : null
                                                            }

                                                            {/*{*/}
                                                            {/*    (selectClass.teacher.privileges.split(':')[1] === '1' &&*/}
                                                            {/*        (selectClass.firstWeekFree && firstWeek) &&*/}
                                                            {/*        selectClass.buttonStatus === constants.BUY_TEXT) ?*/}
                                                            {/*        <Button*/}
                                                            {/*            className="com-btn log-btn mt-3 auto-width"*/}
                                                            {/*            onClick={() => this.viewClassLessons()}>*/}
                                                            {/*            {`${language[lang].ClassResources}`}*/}
                                                            {/*        </Button> : null*/}
                                                            {/*}*/}



                                                            {
                                                                selectClass.buttonStatus === constants.BUY_TEXT  ?
                                                                    <Button
                                                                        id={"pay-btn"}
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => this.purchaseHandler(new Date(), selectClass.id)}>
                                                                        {`${language[lang].PurchaseTheClassPass} (${parseFloat(selectClass.fee ? selectClass.fee : 0).toFixed(2)})`}
                                                                        {/*for ${moment(new Date()).format("MMM")}*/}
                                                                    </Button> : null
                                                            }
                                                            {
                                                                selectClass.buttonStatus === constants.PENDING_TEXT ?
                                                                    <Button
                                                                        className="com-btn pending-btn mt-3 auto-width">
                                                                        {`${language[lang].PaymentPending}`}
                                                                        {/*for ${moment(new Date()).format("MMM")}*/}
                                                                    </Button> : null
                                                            }
                                                            {
                                                                (selectClass.teacher.privileges.split(':')[0] === '1' &&
                                                                    selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                                    <Button
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => commonFunc.joinClassHandler(this.props, selectClass)}>
                                                                        {`${language[lang].JoinTheClass}`}
                                                                    </Button> : null
                                                            }

                                                            {/*always viewed the Class resources button(past class material part)*/}
                                                            {
                                                                selectClass.teacher.privileges.split(':')[1] === '1' &&

                                                                <Button
                                                                    className="com-btn log-btn mt-3 auto-width"
                                                                    onClick={() => this.viewClassLessons()}>
                                                                    {`${language[lang].ClassResources}`}
                                                                </Button>
                                                            }
                                                            {/*{*/}
                                                            {/*    (selectClass.teacher.privileges.split(':')[1] === '1' &&*/}
                                                            {/*        selectClass.buttonStatus === constants.BOUGHT_TEXT) ?*/}
                                                            {/*        <Button*/}
                                                            {/*            className="com-btn log-btn mt-3 auto-width"*/}
                                                            {/*            onClick={() => this.viewClassLessons()}>*/}
                                                            {/*            {`${language[lang].ClassResources}`}*/}
                                                            {/*        </Button> : null*/}
                                                            {/*}*/}
                                                            {
                                                                (selectClass.teacher.privileges.split(':')[3] === '1' &&
                                                                    selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                                    <Button
                                                                        className="com-btn log-btn mt-3 auto-width"
                                                                        onClick={() => this.viewClassPapers(selectClass)}>
                                                                        {`${language[lang].QuizesAndTestPapers}`}
                                                                    </Button> : null
                                                            }

                                                        </div>
                                                }

                                            </Col>
                                        </Row>

                                    </div>
                                }
                            </Container>
                        </section>
                    </main>
                    <CardsFooter/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    selectClass: state.classes.selectClass,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
